import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        // Check if this navigation is from browser back/forward buttons
        // by checking the performance navigation type
        const navigationType = performance.getEntriesByType('navigation')[0]?.type;
        const isBackForwardNavigation = navigationType === 'back_forward';

        // Only scroll to top if it's not a back/forward navigation
        if (!isBackForwardNavigation) {
            window.scrollTo(0, 0);
        }
    }, [pathname, search]);

    return null;
};

export default ScrollToTop;